import React, { useContext, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Fallback } from "../components/Fallback/Fallback";
import { useUserStore } from "@monorepo/store/useUserStore";
import { usePreferences } from "@monorepo/api-hooks/usePreferences";
import { useJobTitleOptions } from "@monorepo/api-hooks/useJobTitleOptions";
import { useJobRoleOptions } from "@monorepo/api-hooks/useJobRoleOptions";
import { useIndustryOptions } from "@monorepo/api-hooks/useIndustryOptions";
import { useServiceInfo } from "@monorepo/api-hooks/useServiceInfo";
import { useUserProfile } from "@monorepo/api-hooks/useUserProfile";
import { EmailTokenFlowContext } from "../App";

// see https://www.robinwieruch.de/react-router-private-routes/
export const ProtectedRoute = () => {
    const { isEmailTokenFlow, setIsEmailTokenFlow } = useContext(EmailTokenFlowContext);
    const prvyFedarationData = localStorage.getItem(PRIVACY_GFNA_LOCAL_STORAGE_KEY);
    const isGFNAAccountFlow = !!prvyFedarationData;
    const { pathname, hash, search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const isSessionValid = useUserStore((state) => state.isSessionValid);
    const updateSession = useUserStore((state) => state.updateSession);
    useEffect(() => {
        if (isGFNAAccountFlow) {
            try {
                const prvyFedarationDataObj = JSON.parse(prvyFedarationData);
                updateSession({
                    email: prvyFedarationDataObj["email"],
                    idToken: prvyFedarationDataObj["id_token"],
                    idpId: prvyFedarationDataObj["idp_id"],
                    accessToken: prvyFedarationDataObj["access_token"],
                    clientId: prvyFedarationDataObj["client_id"],
                    expiration: prvyFedarationDataObj["expiration"],
                });
            } catch (error) {
                console.error("Error parsing prvyFedarationData", error);
            }
        } else if (!!searchParams.get("token") && !!searchParams.get("id")) {
            //setEmailTokenFlow(true);
            updateSession({
                emailToken: searchParams.get("token"),
                //id is the base64 encoded email
                email: atob(searchParams.get("id")),
            });
            setIsEmailTokenFlow(true);
        }
    }, [isGFNAAccountFlow]);
    const { isError, isLoading } = usePreferences({ isAccountFlow: isGFNAAccountFlow });
    useServiceInfo();
    useJobTitleOptions();
    useJobRoleOptions();
    useIndustryOptions();
    useUserProfile();

    let LOGIN_STATUS = "NOT_VALIDATED";
    if (isError) {
        LOGIN_STATUS = "ERROR";
    } else if (isLoading) {
        LOGIN_STATUS = "LOADING";
    } else if (isEmailTokenFlow) {
        LOGIN_STATUS = "EMAIL_TOKEN_FLOW";
    } else if (searchParams.get("token") && searchParams.get("id")) {
        LOGIN_STATUS = "EMAIL_TOKEN_FLOW";
    } else if (isGFNAAccountFlow) {
        LOGIN_STATUS = "GFNA_ACCOUNT_FLOW";
    } else if (isSessionValid()) {
        LOGIN_STATUS = "VALIDATED";
    } else if (IS_LOCAL_BUILD) {
        LOGIN_STATUS = "DEBUG";
    }

    switch (LOGIN_STATUS) {
        case "NOT_VALIDATED":
        case "ERROR":
            //remove the token and id from the url (if exist)
            searchParams.delete("token");
            searchParams.delete("id");
            const newSearch = searchParams.toString() ? `?${searchParams.toString()}` : "";
            //remove the prvyFedarationData from the local storage
            localStorage.removeItem(PRIVACY_GFNA_LOCAL_STORAGE_KEY);
            //save the full url (including hash and search params) to redirect to after login
            sessionStorage.setItem("PrivacyPortalRedirectPath", `${pathname}${newSearch}${hash}`);
            return <Navigate to="/" />;
        case "LOADING":
            return <Fallback />;
        case "EMAIL_TOKEN_FLOW":
        case "GFNA_ACCOUNT_FLOW":
        case "DEBUG":
        case "VALIDATED":
            return <Outlet />;
        default:
            return <Navigate to="/" />;
    }
};
